const LocationCategories = {
    None: 'None',
    Common: 'Common',
    All: 'All',
    Aeroway: 'Aeroway',
    Amenity: 'Amenity',
    Barrier: 'Barrier',
    Boundary: 'Boundary',
    Building: 'Building',
    Education: 'Education',
    Entertainment: 'Entertainment',
    Financial: 'Financial',
    Healthcare: 'Healthcare',
    Historic: 'Historic',
    Leisure: 'Leisure',
    Manmade: 'Manmade',
    Natural: 'Natural',
    Rail: 'Rail',
    Power: 'Power',
    Road: 'Road',
    Shop: 'Shop',
    Sport: 'Sport',
    Sustenance: 'Sustenance',
    Tourism: 'Tourism',
    Transportation: 'Transportation',
    Waterway: 'Waterway',
    Intersection: 'Intersection',
    AddressPoint: 'AddressPoint',
    Others: 'Others',
};

Object.freeze(LocationCategories);

export default LocationCategories;